<!--
<mat-horizontal-stepper labelPosition="bottom" [linear]="true" #stepper>
  <mat-step [optional]="false"> -->
<ng-template matStepLabel>Datos del Vehiculo</ng-template>
<!--Form-Vehicle-->
<article class="wrapper__article position-relative" [ngClass]="{'m-0': isDialog}">
  <i *ngIf="isDialog" matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions"
    (click)="dialogRef.close()"></i>
  <div class="wrapper__article__form" [ngClass]="{'py-5': isDialog}">
    <div class="wrapper__article__form--content" *ngIf="!this.onlyGps">
      <mat-horizontal-stepper labelPosition="bottom" [linear]="true" #stepper class="stepper-form-vehicle">
        <mat-step>
          <ng-template matStepLabel>
            <span>Datos Básicos</span>
          </ng-template>
          <span class="separator-horizontal"></span>
          <!-- License Plate -->
          <div class="row" *ngIf="!vehicle">
            <app-license-plate [inputFormControl]="licensePlateControl"></app-license-plate>
          </div>
          <div class="w-100 mt-2"
            *ngIf="!vehicle && licensePlateControl?.value && licensePlateControl?.errors?.vehicleExistsCompany">
            <div class="col-md-12 alert alert-warning" role="alert">
              El vehículo con placa {{licensePlateControl?.value}} ya existe, no podrás crearlo nuevamente.
              Si deseas ir al detalle de este <span class="underline color-secondary-dark"
                (click)="goToVehicle(licensePlateControl?.value)">haz click aquí</span>
            </div>
          </div>
          <div class="w-100 mt-2" *ngIf="!vehicle && licensePlateControl?.value && 
            (licensePlateControl?.errors?.vehicleExists || licensePlateControl?.errors?.vehicleExistsNotExclusive)">
            <div class="col-md-12 alert alert-warning" role="alert">
              El vehículo con placa {{licensePlateControl.value}} ya existe, y pertenece a otra compañía.
              <span *ngIf="licensePlateControl?.errors?.vehicleExistsNotExclusive"
                class="underline color-secondary-dark" (click)="showModalVehicleCompany(existingVehicle)">Asociarlo a
                esta compañía</span>
            </div>
          </div>

          <hr>

          <!-- Company & License Plate -->
          <div class="row">
            <!--
            Se deshabilita la selección de compañía para dar lugar al deslizador de flota propia
            <div class="col-md-6" *ngIf="!dialogParams?.company">
              <app-select-company [options]="optionsCompany" [inputFormControl]="companySelected">
              </app-select-company>
            </div> -->
            <mat-form-field appearance="outline" class="col-md-6 col-lg-4" *ngIf="canChangeVehicleFleetLoyalty">
              <mat-label>Categoría de flota</mat-label>
              <mat-select [formControl]="fleetLoyaltyCategory" [compareWith]="compareFleetLoyalty"
                (selectionChange)="onSelectFleetLoyalty($event.value)">
                <mat-option *ngFor="let fleetType of listFleetTypes" [value]="fleetType">
                  {{fleetType?.description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Owner -->
          <ng-container>
            <app-person-vehicle [form]="ownerControls" [title]="'Propietario'" (emitUser)="setUser('owner',$event)"
              [requiresDriversFields]="isSameOwnerCtrl?.value"></app-person-vehicle>
          </ng-container>
          <hr>
          <!-- Driver -->
          <div class="row">
            <div class="col-md-12 container-flex container-flex_center">
              <mat-label>¿El propietario es el mismo conductor?</mat-label>
              &nbsp;&nbsp;
              <mat-button-toggle-group #group="matButtonToggleGroup" [formControl]="isSameOwnerCtrl">
                <mat-button-toggle [value]="true" (change)="onChangeIsSameOwner($event.value)">
                  Si
                </mat-button-toggle>
                <mat-button-toggle [value]="false" (change)="onChangeIsSameOwner($event.value)">
                  No
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <app-person-vehicle *ngIf="!isSameOwnerCtrl.value" [form]="driverControls" [title]="'Conductor (opcional)'"
            (emitUser)="setUser('driver',$event)"></app-person-vehicle>
          <hr>
          <!-- Administrator -->
          <div class="row">
            <div class="col-md-6">
              <mat-label>¿El Vehículo cuenta con Tenedor o Administrador?</mat-label>
              &nbsp;&nbsp;
              <mat-button-toggle-group #group="matButtonToggleGroup" [formControl]="hasAdministratorCtrl">
                <mat-button-toggle [value]="true" (change)="onChangeHasAdmin($event)">
                  Si
                </mat-button-toggle>
                <mat-button-toggle [value]="false" (change)="onChangeHasAdmin($event)">
                  No
                </mat-button-toggle>
              </mat-button-toggle-group>
              <mat-error class="mat-error-size"
                *ngIf="!isSameOwnerCtrl.value && ownerControls.value.information.documentTypeId==='3'&& !hasAdministratorCtrl.value">
                Se sugiere añadir administrador cuando el propietario es una empresa
              </mat-error>
            </div>
          </div>
          <ng-container *ngIf="hasAdministratorCtrl.value">
            <span class="separator-horizontal"></span>
            <app-person-vehicle [form]="administratorControls" [title]="'Administrador'"
              (emitUser)="setUser('admin',$event)"></app-person-vehicle>
          </ng-container>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>
            <span>Documentos</span>
          </ng-template>
          <span class="separator-horizontal"></span>
          <ng-container [formGroup]="this.formVehicle"
            *ngIf="this.form.get('vehicle.frontPicture') && this.form.get('vehicle.rightLateralPicture') && this.form.get('vehicle.leftLateralPicture') && this.form.get('vehicle.propertyCard')">
            <div class="form__vehicle_documents">
              <app-user-documents
                *ngIf="form && form?.get('driver')?.value?.information?.document && !utils.isEmpty(form.get('vehicle.id').value)"
                [role]="roles.DRIVER" [form]="form.get('driver')" [hideBtn]="true" [typeAction]="'createVehicle'"
                [isSameOwner]="isSameOwnerCtrl.value && form?.get('driver')?.value?.information?.document === form?.get('owner')?.value?.information?.document">
              </app-user-documents>
              <app-user-documents
                *ngIf="form && form?.get('owner')?.value?.information?.document && !utils.isEmpty(form.get('vehicle.id').value) && !isSameOwnerCtrl.value && form?.get('driver')?.value?.information?.document !== form?.get('owner')?.value?.information?.document"
                [role]="roles.OWNER" [form]="form.get('owner')" [hideBtn]="true" [typeAction]="'createVehicle'">
              </app-user-documents>
              <app-vehicle-documents *ngIf="form && !utils.isEmpty(form.get('vehicle.id').value)" [form]="form"
                [hideBtn]="true" [typeAction]="'createVehicle'">
              </app-vehicle-documents>
            </div>
          </ng-container>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>
            <span>Satelital</span>
          </ng-template>
          <!--GPS-->
          <ng-container>
            <h4 class="text-strong" *ngIf="configStepper?.title">{{configStepper.title}}</h4>
            <br *ngIf="configStepper?.title">
            <app-gps-vehicle [form]="gpsControls"></app-gps-vehicle>
          </ng-container>
        </mat-step>
        <mat-step *ngIf="form?.get('driver.information.document')?.value">
          <ng-template matStepLabel>
            <span>Referencias</span>
          </ng-template>
          <app-vehicle-contacts [form]="form" [fromCreation]="true"></app-vehicle-contacts>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
    <div class="wrapper__article__form--checkbox text-bold">
      <mat-checkbox class="wrap-checkbox cursor-pointer" [formControl]="requireSecurityStudyCtrl"
        *ngIf="!allowCreatingWithoutTruora && stepActive === 0 && isDialog">
        ¿Deseas realizar un nuevo estudio de seguridad? (Si marcas la casilla, iniciará al hacer clic en "Guardar y
        Continuar")
      </mat-checkbox>
    </div>
    <div class="security-alert text-bold">
      <div *ngIf="!allowCreatingWithoutTruora && stepActive === 0 && (requireSecurityStudyCtrl.value || !isDialog)">
        Al hacer clic en "Guardar y continuar" se lanzarán estudios de seguridad para: {{formattedSecurityStudies}}
      </div>
    </div>
    <div class="wrapper__article__form--footer">
      <mat-card-actions>
        <button mat-raised-button class="primary-secondary button-width-auto" (click)="goBack(stepper)" type="button"
          *ngIf="stepActive !== 0">
          Atrás
        </button>
        <button mat-raised-button class="button-width-auto" (click)="goForward()" type="button"
          *ngIf="stepActive < (form?.get('driver.information.document')?.value ? 3 : 2)">
          Guardar y continuar
        </button>
        <button mat-raised-button color="primary" type="button" class="button-width-auto" (click)="onSubmit()"
          *ngIf="stepActive === (form?.get('driver.information.document')?.value ? 3 : 2)">
          Guardar
        </button>
      </mat-card-actions>
    </div>
  </div>
</article>

<!--
    <mat-card-actions *ngIf="this.vehicle" class="mat-card-actions-vehcle text-center">
      <button mat-raised-button color="primary" type="button" class="button-width-auto" (click)="this.onUpdate()">
        Actualizar
      </button>
    </mat-card-actions>
  </mat-step>
  <mat-step [optional]="true">
    <ng-template matStepLabel>Cuenta de Anticipos</ng-template>
    <app-bank-account (emitToParent)="createBankAcountAdvance(stepper,$event)" title='Advance' [id]='this.licensePlate'
      [vehicle]='this.vehicle'>
    </app-bank-account>
    <div>
      <mat-card-actions class="text-right">
        <button mat-raised-button color="primary" type="button" class="button-width-auto" matStepperPrevious>
          Volver
        </button>
        <button mat-raised-button color="primary" type="button" class="warn button-width-auto" matStepperNext>
          Omitir
        </button>
      </mat-card-actions>
    </div>
  </mat-step>
  <mat-step [optional]="true">
    <ng-template matStepLabel>Cuenta de Saldos</ng-template>
    <app-bank-account title='Balance' [id]='this.licensePlate' [vehicle]='this.vehicle'
      (emitToParent)="createBankAcountBalance(stepper,$event)">
    </app-bank-account>
    <div>
      <mat-card-actions class="text-right">
        <button mat-raised-button color="primary" type="button" class="button-width-auto" matStepperPrevious>
          Volver
        </button>
        <button mat-raised-button color="primary" type="button" class="warn button-width-auto"
          (click)='this.goToDetail()'>
          Omitir
        </button>
      </mat-card-actions>
    </div>

  </mat-step>
</mat-horizontal-stepper> -->